<template>
    <div class="email-onboarding-provider mx-auto ov-hidden">
        <header class="acenter">
            <slot name="subtitle">
                <p class="subtitle lh-20 fs-3 m-0">
                    {{
                        $l10n.__(
                            'Pour profiter pleinement de vos emails dans Sellsy, sélectionnez le service que vous utilisez pour vos emails : ',
                        )
                    }}
                </p>
            </slot>
        </header>

        <div class="flex-row flex-bottom jc-space w-5 mx-auto mt-4">
            <div
                v-for="{ id, title, icon } in providers"
                :id="`select-email-provider-${id}`"
                :key="id"
                :class="{ 'b-1-primary-50': isFocus(id) }"
                class="provider-item flex-row flex-bottom pb-3 jc-center b-1 br cpointer white-bkg"
                @click="onValidateProvider(id, title)"
            >
                <div class="flex-column ai-center ov-hidden">
                    <SaasIcon :icon="icon" width="35" height="35" />
                    <p class="mb-0 mt-1 semibold">{{ title }}</p>
                </div>
            </div>
        </div>

        <p class="description fs-2 gray-60 acenter mb-0 mt-3">
            {{
                $l10n.__(
                    'Si vous avez un doute sur votre service, demandez à votre administrateur.',
                )
            }}
        </p>
    </div>
</template>

<script>
import { providers } from 'Config/authenticated/dictionary/onboardingEmail.js';
import Feature from 'Services/Feature';
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

export default {
    name: 'EmailOnboardingProvider',
    components: {
        SaasIcon,
    },
    props: {
        successUrl: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            providers: providers,
            providerFocus: null,
        };
    },
    methods: {
        isFocus(provider) {
            return this.providerFocus === provider;
        },
        onValidateProvider(id, title) {
            if (
                !Feature.isEnabled('email-engine') ||
                (id === 'other' &&
                    (!Feature.isEnabled('nylas-imap-auth') || !Feature.isEnabled('nylas-api-v3')))
            ) {
                this.$emit('validProvider', { id, title });
                this.providerFocus = id;
            } else {
                const referer =
                    this.successUrl === '/'
                        ? '/settings/email'
                        : encodeURIComponent(this.successUrl);
                switch (id) {
                    case 'gmail':
                        window.location.assign(
                            '/?_f=prefsNylas&action=oauthGoogle&successUrl=' + referer,
                        );
                        break;
                    case 'office365':
                        window.location.assign(
                            '/?_f=prefsNylas&action=oauthMicrosoftOffice365&successUrl=' + referer,
                        );
                        break;
                    case 'other':
                        window.location.assign('/nylas/v3/imap/auth?successUrl=' + referer);
                        break;
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.email-onboarding-provider {
    max-width: 450px;

    .provider-item {
        height: 96px;
        width: 96px;
        transition: all 0.3s linear;
        &:hover {
            box-shadow: 0 0 8px 0 #8c909c;
        }
        img {
            max-width: 35px;
            max-height: 35px;
        }
    }
    .description {
        line-height: 16px;
    }
}
</style>
